function displayResult(code) {
    switch (code) {
        case 0:
            $('#save-div').empty();
            $("#save-div").append(`<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`);
            break;
        case 1:
            $("#save-div").empty();
            $("#save-div").append(`<div class="saved-ok"><i class="fa fa-check" aria-hidden="true"></i></div>`);
            break;
        case 2:
            $("#save-div").empty();
            $("#save-div").append(`<div class="saved-fail"><i class="fa fa-times" aria-hidden="true"></i></div>`);
            break;
        case 3:
            $("#save-div").empty();
            break;
        default:
            $("#save-div").empty();
            break;
    }

    setTimeout(function () {
        $('#save-div').empty();
    }, 10000);
}

